module.exports = __webpack_public_path__ + "static/media/shenandoahFloorPlan.d6d55708.png";